import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const accessControlPermissionTypesBreadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.access_control_permission_types.breadcrumb.label1'),
    link: '/access-control',
  },
  {
    label: t('pages.access_control_permission_types.breadcrumb.label2'),
  },
];
